import { render, staticRenderFns } from "./RateFacilityPage.vue?vue&type=template&id=74d6666c&"
import script from "./RateFacilityPage.vue?vue&type=script&lang=js&"
export * from "./RateFacilityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports